module.exports = {
  BOH_TRANSACTIONS_CREATE_REQUEST: 'BOH_TRANSACTIONS_CREATE_REQUEST',
  BOH_TRANSACTIONS_CREATE_SUCCESS: 'BOH_TRANSACTIONS_CREATE_SUCCESS',
  BOH_TRANSACTIONS_CREATE_FAILURE: 'BOH_TRANSACTIONS_CREATE_FAILURE',
};
